import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackWriteClick, trackWriteClickBlocked } from './tracking';
import { useEarlyAccessPaywallContext } from '../../../../../../../packages/EarlyAccessPaywall';
import { EAccessCheckTrackingStatus } from '../../../../../../../packages/EarlyAccessPaywall/shared/components/Provider/Provider';
import { EStatus, ESubscriptionLimitType } from '../../../../../../../packages/EarlyAccessPaywall/shared/types/context';
import { useOfferContext } from '../../../../context';
import { selectEarlyAccessContactsFlowEnabled } from 'shared/selectors/earlyAccess/selectEarlyAccessContactsFlowEnabled';

export const OfferChatButtonContainer: React.FC = () => {
  const {
    offer,
    api,
    isChatAvailable,
    position,
    jsonQuery,
    user: { isAuthenticated },
  } = useOfferContext();
  const earlyAccessContext = useEarlyAccessPaywallContext();
  const checkContactsAccess = earlyAccessContext?.checkContactsAccess;
  const status = earlyAccessContext?.status;
  const isEarlyAccessContactsFlowEnabled =
    // TODO: Удалить фича-тоггл
    useSelector(selectEarlyAccessContactsFlowEnabled) && offer.isEarlyAccessEnabled && earlyAccessContext;

  const handleEarlyAccessFlow = React.useCallback(async () => {
    if (!isAuthenticated) {
      trackWriteClickBlocked({ offer, position, jsonQuery, blockType: EAccessCheckTrackingStatus.Unauthorized });
    }

    const { isConfirmed, trackingStatus } = await checkContactsAccess({
      offerId: offer.id,
      limitType: ESubscriptionLimitType.Chat,
    });

    if (isConfirmed) {
      trackWriteClick({ offer, position, jsonQuery, isEarlyAccess: true });
      api.openChat(offer, position, true, 'Open_listing_agent_block');
    } else if (trackingStatus) {
      trackWriteClickBlocked({ offer, position, jsonQuery, blockType: trackingStatus });
    }
  }, [offer, position, jsonQuery, api, checkContactsAccess, isAuthenticated]);

  const handleClick = React.useCallback(
    async (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();

      if (isEarlyAccessContactsFlowEnabled) {
        await handleEarlyAccessFlow();

        return;
      }

      trackWriteClick({ offer, position, jsonQuery, isEarlyAccess: false });
      api.openChat(offer, position, undefined, 'Open_listing_agent_block');
    },
    [isEarlyAccessContactsFlowEnabled, offer, position, jsonQuery, api, handleEarlyAccessFlow],
  );

  if (!isChatAvailable) {
    return null;
  }

  const isLoading = status === EStatus.Loading && earlyAccessContext?.lastUsedOfferId === offer.id;

  return (
    <Button data-mark="ChatButton" fullWidth size="XS" onClick={handleClick} theme="fill_secondary" loading={isLoading}>
      Написать
    </Button>
  );
};
